import { useTranslation } from '@/i18n/useTranslation';

import { Link } from 'react-router-dom';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="not-found-panel glass-panel">
      <h1>{t('404 — Page not found')}</h1>
      <p>{t("The page you're looking for doesn't exist.")}</p>
      <Link to="/" className="btn btn--primary">
        {t('Back to Dashboard')}
      </Link>
    </div>
  );
}
